<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
                @search-change="searchChange" @refresh-change="refreshChange(page)"
                @selection-change="handleSelectionChange" @size-change="pageSizeChange" @current-change="pageChange">
                <template slot-scope="scope" slot="menuLeft">
                    <el-button size="mini" type="primary" @click="handleAdd" icon="el-icon-plus" plain>
                        新增
                    </el-button>
                    <el-button size="mini" type="danger" @click="handleDel(scope.row)" icon="el-icon-delete" plain>
                        删除
                    </el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <!-- 编辑 -->
                    <el-button size="mini" type="text" @click="handleEdit(scope.row, scope.$index)" icon="el-icon-edit">
                        编辑
                    </el-button>
                    <!-- 删除 -->
                    <el-button size="mini" type="text" @click="handleDel(scope.row)" icon="el-icon-delete">
                        删除
                    </el-button>
                </template>
                <template slot-scope="scope" slot="useType">
                    <span v-if="scope.row.useType == 0">通用</span>
                    <!-- scope.row.useType == 1时是产品，前面有个查看图标 -->
                    <el-button type="text" v-if="scope.row.useType == 1" icon="el-icon-view"
                        @click="handleViewGoods(scope.row)">产品</el-button>
                </template>
            </avue-crud>
            <el-dialog :title="dialogVisibleTitle" :visible.sync="dialogVisible" width="70%"
                :close-on-click-modal="false">
                <el-form :model="form" label-width="120px" :rules="rules" ref="form">
                    <!-- 区域名称 -->
                    <el-form-item label="区域名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入区域名称" />
                    </el-form-item>
                    <!-- 业务员 -->
                    <el-form-item label="业务员" prop="salesmanId">
                        <el-select v-model="form.salesmanId" placeholder="请选择业务员" clearable>
                            <el-option v-for="item in salesmanList" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <!-- 商户列表 -->
                    <el-form-item label="商户列表" prop="list" >
                        <el-button type="text" size="small" @click="sendDialogVisibleChild = true" icon="el-icon-plus">
                            选择商户
                        </el-button>
                        <el-table :data="form.list" style="width: 100%" border>
                            <el-table-column label="商户名称" prop="shopName"></el-table-column>
                            <el-table-column label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="handleDeleteMerchant(scope.$index)"
                                        icon="el-icon-delete">
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <shop-selector :visible.sync="sendDialogVisibleChild" @confirmShopSelector="handleShopSelection"
                            @update:visible="sendDialogVisibleChild = $event" />
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer" v-if="dialogVisibleTitle !== '查看区域'">
                    <el-button type="primary" @click="handleSubmit">保存</el-button>
                    <el-button @click="dialogVisible = false">取消</el-button>
                </div>
            </el-dialog>
        </basic-container>
    </div>
</template>
<script>
import { regionOption } from "@/const/salesCloud/region/regionOption";
import {
    getCouponList,
    getCouponDetail,
    addOrEditCoupon,
    // 获取业务员列表
    getSalesmanList,
    delCoupon,
    sendCoupon,
    oneClickGrant
} from "@/api/salesCloud/region/region";
import ShopSelector from "./components/shopSelector/index.vue";
export default {
    name: "coupon",
    components: {
        ShopSelector,
    },
    data() {
        return {
            tableOption: regionOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            loading: false,
            dialogVisible: false, // 控制弹窗显示
            dialogVisibleTitle: "", // 弹窗标题
            form: {
                name: "", // 区域名称
                salesmanId: "", // 业务员id
                list: [] // 商户列表
            },
            salesmanList: [], // 业务员列表
            dialogVisibleGoods: false, // 查看产品弹窗
            isSelectorVisible: false,
            sendDialogVisibleChild: false, // 选择商户弹窗
            sendRecordVisible: false, // 发放记录弹窗
            couponId: "", // 区域id
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10 //每页显示多少条
            },
            // 表单验证规则
            rules: {
                name: [
                    { required: true, message: "请输入区域名称", trigger: "blur" }
                ],
                // salesmanId: [
                //     { required: true, message: "请输入业务员id", trigger: "blur" }
                // ],
                list: [
                    { required: true, message: "请选择商户列表", trigger: "change" }
                ]
            }
        };
    },
    created() {
        this.handleList();
        getSalesmanList().then(res => {
            this.salesmanList = JSON.parse(res.data).rows;
            console.log(this.salesmanList);
            
        })
    },
    mounted() { },
    computed: {},
    props: [],
    methods: {
        sendRecord(id) {
            this.couponId = id;
            this.sendRecordVisible = true;
        },
        closeSendRecordDialog() {
            this.sendRecordVisible = false;
        },
        handleViewGoods(row) {
            this.clean();
            getCouponDetail(row.id).then(res => {
                let data = JSON.parse(res.data);
                this.findPureWaterGoodsByRootDepartId(data.goodsList);
                this.dialogVisibleGoods = true;
            });
            this.dialogVisibleGoods = true;
        },
        closeDialogGoods() {
            this.dialogVisibleGoods = false;
        },
        handleTypeChange() {
            const val = this.form.type;
            if (val == 1) {
                this.form.useType = 0;
            }
            if (val == 0) {
                this.form.useType = 1;
            }
        },
        handleDeleteMerchant(index) {
            this.form.list.splice(index, 1);
        },
        handleShopSelection(selectedShops) {
            console.log("选中的商户：", selectedShops);
            const existingShops = this.form.list || [];
            const newShops = selectedShops.filter(shop => 
                !existingShops.some(existingShop => existingShop.businessId == shop.id)
            );
            this.form.list = [...existingShops, ...newShops];
            console.log('this.form.list::: ', this.form.list);
        },
        handleDeleteProduct(index) {
            this.form.goodsList.splice(index, 1);
        },
        handleProductSelection(selectedProducts) {
            // console.log("选中的产品：", selectedProducts);
            selectedProducts = selectedProducts.map(item => {
                return {
                    goodsId: item.id,
                    discountAmount: item.discountAmount,
                    price: item.price,
                    name: item.name
                };
            });
            // 在此处处理选中的产品数据
            if (this.form.goodsList.length > 0) {
                this.form.goodsList = this.form.goodsList.concat(selectedProducts.filter(item => {
                    return !this.form.goodsList.some(product => product.id === item.id || product.goodsId === item.id|| product.goodsId === item.goodsId);
                }));
                console.log('this.form.goodsList:::1 ', this.form.goodsList);
            } else {
                this.form.goodsList = selectedProducts;
            }
        },
        handleSendSubmit() {
            let params = this.sendForm.merchant.map(item => {
                return {
                    userId: item.id,
                    num: item.num
                };
            });
            console.log(this.sendForm.coupon,'params::: ', params);
            sendCoupon(this.sendForm.coupon, params).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "发放成功",
                        type: "success"
                    });
                    this.sendDialogVisible = false;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message ? res.message : '发放失败,请重试',
                        type: "error"
                    });
                }
            });
        },
        handleisSelectorVisible(val) {
            // console.log('val::: ', val);
            this.isSelectorVisible = val;
        },
        handleSend(row) {
            this.sendForm = {
                merchant: [], // 选择的商户
                coupon: row.id, // 选择的区域
            };
            this.sendDialogVisible = true;
        },
        oneClickGrant(id) {
            oneClickGrant(id).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "发放成功",
                        type: "success"
                    });
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message ? res.message : '发放失败,请重试',
                        type: "error"
                    });
                }
            });
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // 表单校验通过，执行提交操作
                    // console.log("表单校验通过，提交表单：", this.form);
                    let params = {
                        ...this.form,                        
                        name: this.form.name,
                        salesmanId: this.form.salesmanId,
                        list: this.form.list.map(item => {
                            // areaId
                            if(item.areaId){
                                return {
                                    ...item,
                                };
                            }else{
                                return {
                                    businessId: item.id,
                                    clientType: "JOINS_MERCHANT"
                                };
                            }
                        }),
                    };
                    console.log("params::: ", params);
                    let isEdit = this.dialogVisibleTitle === "编辑区域";
                    addOrEditCoupon(params, isEdit).then(res => {
                        if (res.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success"
                            });
                            this.handleList();
                            this.dialogVisible = false;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message ? res.message : '操作失败,请重试',
                                type: "error"
                            });
                        }
                    });
                } else {
                    // console.log("表单校验失败");
                    return false;
                }
            });
        },
        handleAdd() {
            this.clean();
            this.dialogVisible = true;
            this.dialogVisibleTitle = "新增区域";
        },
        handleEdit(row) {
            console.log('row::: ', row);
            
            this.clean();
            getCouponDetail(row.id).then(res => {
                let data = JSON.parse(res.data);
                console.log('data::1 ', data);
                this.dialogVisible = true;
                this.dialogVisibleTitle = "编辑区域";
                this.form = {
                    ...data,
                    id: row.id, // 区域id
                    name: row.name, // 区域名称  
                    list: data.list.map(item => {
                        return {
                            ...item,
                            shopName: item.name,
                        };
                    }), // 商户列表
                }
            });
        },
        handleView(row) {
            // console.log('row::: ', row);
            this.clean();
            getCouponDetail(row.id).then(res => {
                let data = JSON.parse(res.data);
                this.findPureWaterGoodsByRootDepartId(data.goodsList);
                this.dialogVisible = true;
                this.dialogVisibleTitle = "查看区域";
                this.form = {
                    ...data,
                    id: row.id ? row.id : '', // 区域id
                    name: row.name, // 区域名称
                    type: row.type, // 区域类型，默认值为区域
                    price: row.price, // 抵现券金额（如果是区域可以忽略）
                    useType: row.useType, // 使用范围，默认值为通用
                    goodsList: this.form.goodsList, // 可用产品（仅在选择“产品”时使用）
                    startDate: row.startDate,
                    endDate: row.endDate,
                    remarks: row.remarks, // 使用说明
                };
            });
        },
        clean() {
            this.form = {
                name: "", // 区域名称
                type: "", // 区域类型，默认值为区域
                price: 0, // 抵现券金额（如果是区域可以忽略）
                useType: "", // 使用范围，默认值为通用
                goodsList: [], // 可用产品（仅在选择“产品”时使用）
                startDate: '',
                endDate: '',
                remarks: "", // 使用说明
            };
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = this.page.currentPage;
            params.size = pageSize;
            this.downloadData = params;
            getCouponList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize
                };
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page;
            params.size = this.page.pageSize;
            this.downloadData = params;
            getCouponList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            this.tableLoading = true;
            params.page = this.page.currentPage;
            params.size = this.page.pageSize;
            getCouponList(params).then(res => {
                if (res.code != 500) {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                    this.tableData = [];
                }
            });
        },
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page.currentPage;
            params.size = page.pageSize;
            this.downloadData = params;
            getCouponList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize
                };
                this.tableLoading = false;
            });
        },
        handleList() {
            this.tableLoading = true;
            let params = {
                page: this.page.currentPage,
                size: this.page.pageSize
            };
            this.downloadData = params;
            getCouponList(params).then(res => {
                let data = JSON.parse(res.data);
                // console.log('data::: ', data);
                this.tableData = data.rows;
                console.log('this.tableData::: ', this.tableData);
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            });
            // this.getDepartment();
        },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange(val) {
            let ids = val.map(item => {
                return item.id;
            });
            this.ids = ids.join(",");
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel(row) {
            let ids = "";
            ids = this.ids;
            if (row) {
                ids = row.id;
                this.$confirm(`您确定删除该条数据吗？`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        delCoupon(ids)
                            .then(res => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功删除",
                                        type: "success"
                                    });
                                    this.handleList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message ? res.message : '删除失败,请重试',
                                        type: "error"
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error"
                                });
                            });
                    })
                    .catch(() => { });
            } else {
                if (!ids) {
                    this.$message({
                        showClose: true,
                        message: "未选中任何数据",
                        type: "error"
                    });
                    return;
                }
                let length = ids.split(",").length;
                this.$confirm(
                    `共选中${length}条数据吗，您确定批量删除吗？`,
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                )
                    .then(() => {
                        delCoupon(ids)
                            .then(res => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功",
                                        type: "success"
                                    });
                                    this.handleList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message,
                                        type: "error"
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error"
                                });
                            });
                    })
                    .catch(() => { });
            }
        },
    }
};
</script>

<style lang="scss" scoped>
.blockBox {
    display: flex;
    align-items: center;

    span {
        margin-left: 10px;
    }
}

.table-container {
    padding: 8px 10px;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}

.line {
    text-align: center;
    line-height: 32px;
}

::v-deep .el-form-item__label {
    color: #606266 !important;
    font-weight: 700 !important;
}
</style>